<template>
    <div>
        <keep-alive>
      <div class="main-container">
        <breadcrumb :list="breadcrumbList" />
        <tl-tabs :tabs="tabs" :customclass="true" class="margintop-20" @changeTab="onTabChange()">
        <tl-tab>
          <fbpLock />
        </tl-tab>
        <tl-tab>
          <fbpDeclaration />
        </tl-tab>
      </tl-tabs>
      </div>
    </keep-alive>
    </div>
</template>
<script>
import { computed } from 'vue';
import fbpLock from "./fbpLock.vue"
import fbpDeclaration from "./fbpDeclarationLock.vue"
export default{
  components:{
    fbpLock,
    fbpDeclaration
  },
    data(){
        return{
            tabs: [
        {
          header: "FBP Lock"
        },
        {
          header: "Declaration Lock Unlock"
        }
      ],
      breadcrumbList: [
        {
          name: "FBP",
          url: `/dashboard/${this.$route.params.entity_index}/HumanResources/FBP/FBPDeclaration`,
        },
        {
          name: "FBP Declaration",
          url: `/dashboard/${this.$route.params.entity_index}/HumanResources/FBP/FBPDeclaration`,
        },
      ],
        }
    },
    mounted(){

    },
    activated(){

    },
    computed:{

    }
}
</script>